/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CategoryStatView', ["ServiceStatView",
    function (ServiceStatView) {
        var CategoryStatView = function (category, parentCategoryStatView) {
            this.label = "";
            this.nbBookingsOrSales = 0;
            this.color = "";
            this.parentCategoryStatView = parentCategoryStatView;

            this.equivalentCategory = category;

            this.categoryStatViews = [];
            this.serviceStatViews = [];
            this.globalServiceStatViews = [];

            this.ca = 0;

            if (category)
                this.loadData(category);
        };

        CategoryStatView.prototype.addServiceStatView = function (serviceStatView) {
            if (serviceStatView != undefined && serviceStatView != null) {
                this.serviceStatViews.push(serviceStatView);
                this.addGlobalServiceStatView(serviceStatView);
            }
        };
        CategoryStatView.prototype.addGlobalServiceStatView = function (serviceStatView) {
            if (serviceStatView != undefined && serviceStatView != null) {
                if (this.globalServiceStatViews.indexOf(serviceStatView) == -1)
                    this.globalServiceStatViews.push(serviceStatView);
                if (this.parentCategoryStatView)
                    this.parentCategoryStatView.addGlobalServiceStatView(serviceStatView);

            }
        };
        CategoryStatView.prototype.addCategoryStatView = function (categoryStatView) {
            if (categoryStatView != undefined && categoryStatView != null)
                this.categoryStatViews.push(categoryStatView);
        };
        CategoryStatView.prototype.loadData = function (category) {
            this.setColor(category);
            this.label = category.label;
            for (var i = 0; i < category.categories.length; i++) {
                var newCategoryStatViewFille = new CategoryStatView(category.categories[i], this);
                this.addCategoryStatView(newCategoryStatViewFille);
            }
            for (i = 0; i < category.services.length; i++) {
                var newServiceStatView = new ServiceStatView(category.services[i], this);
                this.addServiceStatView(newServiceStatView);
            }
        };

        CategoryStatView.prototype.setColor = function (category) {
            if (category.style == null && category.parentCategory != undefined && category.parentCategory != null)
                this.setColor(category.parentCategory);
            if (category.style != null && category.style.indexOf("background") != -1) {
                var index = category.style.indexOf("\"", category.style.indexOf("background") + 13);
                if (index != -1)
                    this.color = category.style.substr(category.style.indexOf("background") + 13, index - category.style.indexOf("background") - 13);
                else
                    this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
                if (this.color == "white")//inverse for visibility
                    this.color = "black";
            }
        };
        CategoryStatView.prototype.setPricesFromBookings = function (bookings) {
            // Set ca values for categoryViews / serviceStatViews / customers
            for (var i = 0; i < bookings.length; i++) {
                for (var j = 0; j < bookings[i].bookingServices.length; j++) {
                    var serviceStatView = this.getServiceStatView(bookings[i].bookingServices[j].service);
                    if (serviceStatView != null) {
                        if (bookings[i].bookingServices[j].dayHr) // if bookingService is not affected to an Hr
                        {
                            // set CA to serviceStatViews
                            serviceStatView.ca += bookings[i].bookingServices[j].price;
                            // set CA to categoryStatViews
                            serviceStatView.parentCategoryStatView.setValuesToParentCategories(bookings[i].bookingServices[j].price);

                            serviceStatView.nbBookingsOrSales++;

                            serviceStatView.bookingServices.push(bookings[i].bookingServices[j]);
                        }
                    }
                }
            }
        };
        CategoryStatView.prototype.setPricesFromSales = function (sales) {
            // Set ca values for categoryViews / serviceStatViews / customers
            var price;
            for (var i = 0; i < sales.length; i++) {
                if (sales[i].status == "sold" || sales[i].status == "credit" || sales[i].status == "canceled")
                    for (var j = 0; j < sales[i].saleServices.length; j++) {

                        var serviceStatView = this.getServiceStatView(sales[i].saleServices[j].service);
                        if (serviceStatView != null) {
                            //if(sales[i].saleServices[j].humanResource) // if bookingService is not affected to an Hr
                            {
                                // set CA to serviceStatViews
                                price = sales[i].saleServices[j].price - sales[i].saleServices[j].price * sales[i].discountPercent / 100;
                                serviceStatView.ca += price;
                                // set CA to categoryStatViews
                                serviceStatView.parentCategoryStatView.setValuesToParentCategories(price);

                                if (sales[i].status == "sold" || sales[i].status == "canceled")
                                    serviceStatView.nbBookingsOrSales++;
                                else
                                    serviceStatView.nbBookingsOrSales--;
                                serviceStatView.saleServices.push(sales[i].saleServices[j]);
                            }
                        }
                    }

            }

        };
        CategoryStatView.prototype.setValuesToParentCategories = function (ca) {
            this.ca += ca;
            this.nbBookingsOrSales++;
            if (this.parentCategoryStatView != null)
                this.parentCategoryStatView.setValuesToParentCategories(ca);
        };

        CategoryStatView.prototype.getServiceStatView = function (service) {
            if (service) {
                var serviceStatView = null;
                for (var i = 0; i < this.serviceStatViews.length; i++) {
                    if (this.serviceStatViews[i].serviceId == service.id)
                        serviceStatView = this.serviceStatViews[i];
                }
                if (serviceStatView == null && this.categoryStatViews.length > 0) {
                    for (i = 0; i < this.categoryStatViews.length; i++) {
                        serviceStatView = this.categoryStatViews[i].getServiceStatView(service);
                        if (serviceStatView != null)
                            return serviceStatView;
                    }
                }
            }
            return serviceStatView;
        };

        CategoryStatView.prototype.getCategoryStatViewById = function (id) {
            if (this.categoryStatViews[id] != undefined)
                return this.categoryStatViews[id];
            else
                return null;
        };
        CategoryStatView.prototype.getServiceStatViewById = function (id) {
            if (this.serviceStatViews[id] != undefined)
                return this.serviceStatViews[id];
            else
                return null;
        };


        CategoryStatView.prototype.clearValues = function () {
            this.clearPrices();
            this.clearNbBookings();
        };
        CategoryStatView.prototype.clearPrices = function () {
            this.ca = 0;
            for (var i = 0; i < this.serviceStatViews.length; i++) {
                this.serviceStatViews[i].ca = 0;
                this.serviceStatViews[i].bookingServices = [];
                this.serviceStatViews[i].saleServices = [];
            }
            for (i = 0; i < this.categoryStatViews.length; i++) {
                this.categoryStatViews[i].clearPrices();
            }
        };
        CategoryStatView.prototype.clearNbBookings = function () {
            this.nbBookingsOrSales = 0;
            for (var i = 0; i < this.serviceStatViews.length; i++)
                this.serviceStatViews[i].nbBookingsOrSales = 0;
            for (i = 0; i < this.categoryStatViews.length; i++)
                this.categoryStatViews[i].clearNbBookings();
        };

        return CategoryStatView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/CategoryStatView.js